/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DeleteIcon from '@mui/icons-material/Delete';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './AdvancedFilter.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import AdvancedFilterMultiSelectFilter from './AdvancedFilterMultiSelectFilter';
import AdvancedFilterCalendarFilter from './AdvancedFilterCalendarFilter';
import AdvancedFilterMultiInputFilter from './AdvancedFilterMultiInputFilter';
import ProfileFilter from 'components/ProfileFilter';

const AdvancedFilter = ({ filters, handlerFiltersChange, defaultFilters, ...props }) => {
  const [activeFilters, setActiveFilters] = useState(defaultFilters || {});
  const skipInitialSync = useRef(!!defaultFilters);
  const intl = useIntl();

  useEffect(() => {
    if (skipInitialSync.current) {
      skipInitialSync.current = false;
      return;
    }
    handlerFiltersChange(activeFilters);
  }, [activeFilters]);

  const clearFilters = () => {
    setActiveFilters({});
  };

  const updateDayRange = (key, dayRange) => {
    const newActiveFilters = { ...activeFilters, [key]: dayRange };
    setActiveFilters(newActiveFilters);
  };

  const onClickMultiSelectFilter = (filter, element) => {
    const newActiveFilters = { ...activeFilters };
    const index = newActiveFilters[filter]?.indexOf(element);

    if (index > -1) {
      // Element is already selected, remove it
      newActiveFilters[filter].splice(index, 1);
      if (newActiveFilters[filter].length === 0) {
        // If no elements left in the filter, remove the filter
        delete newActiveFilters[filter];
      }
    } else {
      // Element is not selected, add it
      if (!newActiveFilters[filter]) {
        // If the filter is not already in active filters, initialize it
        newActiveFilters[filter] = [];
      }

      // Add the new element to the filter
      newActiveFilters[filter].push(element);
    }

    setActiveFilters(newActiveFilters);
  };

  const handleChangeMultiInput = (filter, items) => {
    const activeFiltersCopy = { ...activeFilters, [filter]: items };
    if (items.length === 0) {
      delete activeFiltersCopy[filter];
    }
    setActiveFilters(activeFiltersCopy);
  };

  const filterComponents = {
    date: (filter) => (
      <AdvancedFilterCalendarFilter
        filterSchema={filters[filter]}
        filterKey={filter}
        onChange={(range) => updateDayRange(filter, range)}
        value={activeFilters[filter]}
      />
    ),
    input: (filter) => (
      <AdvancedFilterMultiInputFilter
        filterSchema={filters[filter]}
        filterKey={filter}
        onChange={(items) => handleChangeMultiInput(filter, items)}
        values={activeFilters[filter]}
      />
    ),
    multiple: (filter) => (
      <AdvancedFilterMultiSelectFilter
        filterSchema={filters[filter]}
        filterKey={filter}
        onChange={(dayRange) => onClickMultiSelectFilter(filter, dayRange)}
        activeOptions={activeFilters[filter]}
      />
    ),
    profile: (filter) => (
      <ProfileFilter
        filterSchema={filters[filter]}
        filterKey={filter}
        setProfileParams={(profiles) =>
          handleChangeMultiInput(filter, profiles)
        }
        className="mb-2 pr-4"
        values={activeFilters[filter]}
        withoutTitle
      />
    ),
  };

  const renderFilterContent = (filter, index) => {
    const filterObject = filters[filter];
    if (!filterObject.inputType) return null;

    const filterType = filterObject.inputType.toLowerCase();
    if (filterComponents[filterType]) {
      return filterComponents[filterType](filter);
    }
  };

  return (
    <div className={`${styles['filter-parent']} d-flex`}>
      {Object.keys(filters).map((filter, index) => (
        <div className={`${styles['dropdown']} mr-3`} align="start" key={index}>
          <p className={styles['dropbtn']}>
            {intl.formatMessage({
              id: `FILTERS.${filter.toUpperCase()}.NAME`,
            })}{' '}
            <KeyboardArrowDownIcon className={styles['arrow']} />
            <b>
              {activeFilters?.[filter]
                ? `(${activeFilters?.[filter].length ?? 1})`
                : ''}
            </b>
          </p>
          <div className={styles['dropdown-content']} style={{ zIndex: 5 }}>
            {renderFilterContent(filter, index)}
          </div>
        </div>
      ))}
      {Object.keys(activeFilters).length > 0 && (
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip" {...props}>
              <FormattedMessage id="GENERAL.CLEAR_FILTERS" />
            </Tooltip>
          }
        >
          <div onClick={clearFilters} className={styles['delete']}>
            <DeleteIcon />
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default AdvancedFilter;
